document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.npbp-bundle-tab-product');

    sections.forEach(section => {

        // Remove extra DOM element logic
        function removeExtraEl(section, tabWrapper, contentWrapper, tabSelector, contentSelector) {
            const tabWrappers = section.querySelectorAll(tabWrapper);
            if (!tabWrappers.length) return;
            tabWrappers.forEach(w => {
                w.querySelectorAll(contentSelector).forEach(el => el.remove());
            });
            
            const contentWrappers = section.querySelectorAll(contentWrapper);
            if (!contentWrappers.length) return;
            contentWrappers.forEach(w => {
                w.querySelectorAll(tabSelector).forEach(el => el.remove());
            });
        }

        // Align product card info height logic
        function alignProductCardInfoHeight() {
            const activeCards = section.querySelectorAll('.npbp-btp-group-products__cards.active');
            if (!activeCards.length) return;
            activeCards.forEach(cards => {
                const productIntros = cards.querySelectorAll('.npbp-btp-group-product__intro');
                if (!productIntros.length) return;
                let maxH = 0;
                productIntros.forEach(el => {
                    const h = el.offsetHeight || el.getBoundingClientRect().height || el.scrollHeight;
                    if (h > maxH) maxH = h;
                });
                const root = cards.closest('.npbp-btp-group__products') || section;
                root.style.setProperty('--max-prod-info-height', maxH + 'px');
            });
        }

        function alignProductCardInfoHeightAsync() {
            requestAnimationFrame(() => {
                requestAnimationFrame(alignProductCardInfoHeight);
            });
        }

        function syncNpbpBannerAspect(blockBg) {
            if (!blockBg || !blockBg.classList.contains('npbp-btp-group__block-bg')) return;
            const panel = blockBg.closest('.npbp-btp-group__block-content');
            if (!panel) return;
            const d = blockBg.getAttribute('data-aspect-desktop');
            const m = blockBg.getAttribute('data-aspect-mobile');
            if (d) {
                panel.style.setProperty('--aspect-ratio', d);
            }
            if (m) {
                panel.style.setProperty('--mobile-aspect-ratio', m);
            } else {
                panel.style.removeProperty('--mobile-aspect-ratio');
            }
        }

        function buildNpbpBannerStacks(section) {
            function makeBannerBgEl(opts) {
                var id = opts.id;
                var deskUrl = opts.deskUrl || '';
                var mobUrl = opts.mobUrl || '';
                var aspectDesktop = opts.aspectDesktop || '';
                var aspectMobile = opts.aspectMobile || '';
                var alt = opts.alt || '';
                var isActive = opts.isActive;

                var wrap = document.createElement('div');
                wrap.className = 'npbp-btp-group__block-bg' + (isActive ? ' active' : '');
                if (id) wrap.setAttribute('data-npbpgps-id', id);
                if (aspectDesktop) wrap.setAttribute('data-aspect-desktop', aspectDesktop);
                if (aspectMobile) wrap.setAttribute('data-aspect-mobile', aspectMobile);

                if (!deskUrl) {
                    return wrap;
                }

                var picD = document.createElement('picture');
                picD.className = mobUrl ? 'image only-desktop' : 'image';
                var imgD = document.createElement('img');
                imgD.loading = 'lazy';
                imgD.alt = alt;
                imgD.src = deskUrl;
                picD.appendChild(imgD);
                wrap.appendChild(picD);

                if (mobUrl) {
                    var picM = document.createElement('picture');
                    picM.className = 'image only-mobile';
                    var imgM = document.createElement('img');
                    imgM.loading = 'lazy';
                    imgM.alt = alt;
                    imgM.src = mobUrl;
                    picM.appendChild(imgM);
                    wrap.appendChild(picM);
                }

                return wrap;
            }

            section.querySelectorAll('.npbp-btp-group__block-content').forEach(function (panel) {
                var stack = panel.querySelector('.js-npbpg-banner-stack');
                if (!stack) return;

                var defDesk = panel.getAttribute('data-npbpg-default-desk-url') || '';
                var defMob = panel.getAttribute('data-npbpg-default-mob-url') || '';
                var defAspectD = panel.getAttribute('data-npbpg-default-desk-aspect') || '';
                var defAspectM = panel.getAttribute('data-npbpg-default-mob-aspect') || '';
                var defAlt = panel.getAttribute('data-npbpg-default-banner-alt') || '';

                var tabsRow = panel.querySelector('.npbp-btp-group__tabs');
                var triggers = tabsRow
                    ? [].slice.call(tabsRow.querySelectorAll('.npbp-btp-group-products__tab-trigger'))
                    : [];

                stack.innerHTML = '';

                if (triggers.length) {
                    triggers.forEach(function (btn, i) {
                        var gpsId = btn.getAttribute('data-npbpgps-id');
                        var ownD = btn.getAttribute('data-npbpg-own-desk-url') || '';
                        var ownM = btn.getAttribute('data-npbpg-own-mob-url') || '';
                        var ownAD = btn.getAttribute('data-npbpg-own-desk-aspect') || '';
                        var ownAM = btn.getAttribute('data-npbpg-own-mob-aspect') || '';
                        var btnAlt = btn.getAttribute('data-npbpg-banner-alt') || defAlt;

                        var deskUrl = ownD || defDesk;
                        var mobUrl = ownM || defMob;

                        var aspectD = ownAD || defAspectD;
                        var aspectM = '';
                        if (mobUrl) {
                            if (ownM) {
                                aspectM = ownAM || defAspectM || '';
                            } else {
                                aspectM = defAspectM || '';
                            }
                            if (!aspectM && aspectD) aspectM = aspectD;
                        }

                        stack.appendChild(
                            makeBannerBgEl({
                                id: gpsId,
                                deskUrl: deskUrl,
                                mobUrl: mobUrl,
                                aspectDesktop: deskUrl ? aspectD : '',
                                aspectMobile: deskUrl && mobUrl ? aspectM : '',
                                alt: btnAlt,
                                isActive: i === 0,
                            })
                        );
                    });
                } else if (defDesk) {
                    stack.appendChild(
                        makeBannerBgEl({
                            id: '',
                            deskUrl: defDesk,
                            mobUrl: defMob,
                            aspectDesktop: defAspectD,
                            aspectMobile: defMob ? defAspectM || defAspectD : '',
                            alt: defAlt,
                            isActive: true,
                        })
                    );
                }

                var activeSlide =
                    stack.querySelector('.npbp-btp-group__block-bg.active') ||
                    stack.querySelector('.npbp-btp-group__block-bg');
                if (activeSlide) syncNpbpBannerAspect(activeSlide);
            });
        }

        // Tab change logic
        function tabChange(section, tabEls, contentSelectors, id, onActivate) {
            const tabs = section.querySelectorAll(tabEls);
            const selectors = Array.isArray(contentSelectors) ? contentSelectors : [contentSelectors];
            const contentLists = selectors.map(sel => [...section.querySelectorAll(sel)]);
            if (!tabs.length || !contentLists.some(list => list.length)) return;

            function setActiveContents(tabAttrValue) {
                contentLists.forEach(list => {
                    list.forEach(contentItem => {
                        if (!contentItem || typeof contentItem.getAttribute !== 'function') return;
                        if (tabAttrValue === contentItem.getAttribute(id)) {
                            contentItem.classList.add('active');
                            if (typeof onActivate === 'function') {
                                onActivate(contentItem);
                            }
                        } else {
                            contentItem.classList.remove('active');
                        }
                    });
                });
            }

            if (tabs.length) {
                const firstAttr = tabs[0].getAttribute(id);
                tabs[0].classList.add('active');
                setActiveContents(firstAttr);
            }

            tabs.forEach(tabItem => {
                tabItem.addEventListener('click', function () {
                    tabs.forEach(t => t.classList.remove('active'));
                    tabItem.classList.add('active');
                    setActiveContents(tabItem.getAttribute(id));
                    alignProductCardInfoHeightAsync();
                });
            });
        }

        // Init sticky tabs logic
        function initStickyTabs() {
            const tabs = section.querySelector('.npbp-bundle-tab-product__tabs');
            const allProducts = section.querySelectorAll('.npbp-btp-group-products__cards');

            if (!tabs || !allProducts.length) return;

            function getSectionPaddingTop() {
                return parseInt(getComputedStyle(section).paddingTop, 10) || 0;
            }

            function getVisibleProducts() {
                return Array.from(allProducts).find(el => {
                return getComputedStyle(el).display !== 'none';
                });
            }

            function onScroll() {
                const paddingTop = getSectionPaddingTop();
                const sectionTop = section.getBoundingClientRect().top + window.scrollY;
                const triggerStart = sectionTop + paddingTop;
                const scrollY = window.scrollY;

                const visibleProducts = getVisibleProducts();

                if (!visibleProducts) {
                tabs.classList.remove('fixed');
                return;
                }

                const productsTop = visibleProducts.getBoundingClientRect().top;

                if (scrollY >= triggerStart && productsTop > 0) {
                tabs.classList.add('fixed');
                } else {
                tabs.classList.remove('fixed');
                }
            }

            const observer = new MutationObserver(() => {
                onScroll();
            });

            allProducts.forEach(el => {
                observer.observe(el, {
                attributes: true,
                attributeFilter: ['style', 'class'],
                });
            });

            window.addEventListener('scroll', onScroll, { passive: true });
            onScroll();
        }

        // Bind tab trigger first child logic
        function bindTabTriggerFirstChild(tabEl, childTabsElOrList) {
            if (!tabEl || !childTabsElOrList) return;
            function getFirstChild() {
                if (childTabsElOrList.length !== undefined) {
                    return childTabsElOrList[0] || null;
                }
                if (typeof childTabsElOrList.querySelector === 'function') {
                    return childTabsElOrList.querySelector('.npbp-btp-group-products__tab-trigger') || null;
                }
                return null;
            }
            tabEl.addEventListener('click', () => {
                const first = getFirstChild();
                if (first && typeof first.click === 'function') first.click();
            });
        }

        // Click tab scroll into center logic
        function bindScrollIntoCenter(section, scrollerSelector, triggerSelector) {
            const scroller = section.querySelector(scrollerSelector);
            if (!scroller) return;
            const triggers = section.querySelectorAll(triggerSelector);
            if (!triggers.length) return;
            if(window.innerWidth >= 769) return;
            
            function center(tab) {
                requestAnimationFrame(() => {
                    const tabCenter = tab.offsetLeft + tab.offsetWidth / 2;
                    const scrollerCenter = scroller.clientWidth / 2;

                    scroller.scrollTo({
                        left: tabCenter - scrollerCenter,
                        behavior: 'smooth'
                    });
                });
            }

            triggers.forEach(tabEl => {
                tabEl.addEventListener('click', () => center(tabEl));
            });
        }

        removeExtraEl(section, '.npbp-bundle-tab-product__tabs', '.npbp-bundle-tab-product__contents', '.npbp-btp-group__block-tab-trigger', '.npbp-btp-group__block-content');
        removeExtraEl(section, '.npbp-bundle-tab-product__tabs', '.npbp-btp-group__products', '.npbp-btp-group__block-tab-trigger', '.npbp-btp-group__products');
        removeExtraEl(section, '.npbp-btp-group__tabs', '.npbp-btp-group__products', '.npbp-btp-group-products__tab-trigger', '.npbp-btp-group-products__cards');

        buildNpbpBannerStacks(section);

        tabChange(section, '.npbp-btp-group__block-tab-trigger', '.npbpgb-content', 'data-npbpg-id');
        tabChange(
            section,
            '.npbp-btp-group-products__tab-trigger',
            ['.npbp-btp-group-products__cards', '.npbp-btp-group__block-bg'],
            'data-npbpgps-id',
            syncNpbpBannerAspect
        );

        alignProductCardInfoHeightAsync();

        bindScrollIntoCenter(section, '.npbp-bundle-tab-product__tabs', '.npbp-btp-group__block-tab-trigger');

        // Bind tab trigger first child logic
        const parentTabs = section.querySelectorAll('.npbp-btp-group__block-tab-trigger');
        parentTabs.forEach(tab => {
            const targetId = tab.getAttribute('data-npbpg-id');
            const container = section.querySelector('.npbpgb-content[data-npbpg-id="' + targetId + '"]');
            if (!container) return;
            const childTriggers = container.querySelectorAll('.npbp-btp-group-products__tab-trigger');
            if (!childTriggers.length) return;
            bindTabTriggerFirstChild(tab, childTriggers);
        });

        initStickyTabs();

        // ATC logic
        function addProduct(elem, type) {
            section.querySelectorAll(elem).forEach(function (elem) {
            elem.onclick = function (e) {
                e.preventDefault();

                // Get the button and loader elements
                var buttonElement = this.querySelector('.icon-cart');
                var loaderElement = this.querySelector('.loader');

                // Hide the button and show the loader
                buttonElement.style.display = 'none';
                loaderElement.classList.remove('hide');

                let formData = {
                items: [
                    {
                    id: elem.getAttribute('data-variant-id'),
                    quantity: 1,
                    },
                ],
                };
                fetch('/cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (json) {
                    if (type == 'checkout') {
                    window.location.href = '/checkout';
                    } else {
                    theme.Cart.prototype._onProductAdded();
                    }
                })
                .finally(() => {
                    // Show the button and hide the loader
                    buttonElement.style.display = 'block';
                    loaderElement.classList.add('hide');
                });
            };
            });
        }

        if (section.querySelectorAll('.atc-btn').length > 0) {
            addProduct('.atc-btn', '');
        }

    });
});
